import { Loader2 } from 'lucide-react';

export function FullPageSpinner({ label }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-1 flex-col items-center justify-center gap-3"
    >
      <Loader2 className="text-accent size-8 animate-spin" aria-hidden />
      {label ? <p className="text-muted-foreground text-sm">{label}</p> : null}
      <span className="sr-only">{label ?? 'Loading'}</span>
    </div>
  );
}
